import { ethers } from "ethers";

// Polygon Mainnet
// const defaultRPC = "https://polygon-bor.publicnode.com";
// const defaultRPC = "https://rpc-mumbai.maticvigil.com/";

// BSC Testnet
// const defaultRPC = "https://data-seed-prebsc-1-s1.binance.org:8545/";
// const defaultRPC = "https://bsc-dataseed.binance.org/";

 const defaultRPC = [
'https://bsc-dataseed.binance.org/',
'https://bsc-mainnet.gateway.tatum.io/',
'https://bsc.publicnode.com',
'https://public-bsc-mainnet.fastnode.io/' ]


// const defaultRPC = "https://rpc-amoy.polygon.technology";
// const defaultRPC = "https://polygon-rpc.com/";
// const defaultRPC = "https://polygon.llamarpc.com";
// const defaultRPC = "wss://polygon-bor-rpc.publicnode.com";
// const defaultRPC = "https://rpc-mumbai.maticvigil.com/";
// const defaultRPC = "http://127.0.0.1:8546/";

const getProvider = (defaultRpc = false) => {
    if (window.ethereum && !defaultRpc) {
        return new ethers.providers.Web3Provider(window.ethereum);
    }
    return new ethers.providers.JsonRpcProvider(defaultRPC);
};

export default getProvider;